module.exports = __webpack_public_path__ + "img/3.5fb96762.png";